function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import moment from 'js-utils/moment';
import { START_DATE, END_DATE } from '../constants';
var REF_INPUT_MAP = {
  startDate: '_startDateInput',
  endDate: '_endDateInput'
};

var DateInput = function DateInput(_ref) {
  var onFocus = _ref.onFocus,
      classes = _ref.classes,
      date = _ref.date,
      placeholder = _ref.placeholder,
      getRef = _ref.getRef,
      dataSpec = _ref.dataSpec;
  return React.createElement("div", {
    className: classes,
    onFocus: onFocus,
    tabIndex: 0,
    role: "button",
    ref: getRef,
    "data-spec": dataSpec
  }, date || placeholder);
};

var DateRangeInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DateRangeInput, _PureComponent);

  function DateRangeInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DateRangeInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateRangeInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_getRef", function (refName, ref) {
      _this[refName] = ref;
      return _this[refName];
    });

    return _this;
  }

  _createClass(DateRangeInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var focusedInput = _ref2.focusedInput;

      if (focusedInput) {
        var refToFocus = REF_INPUT_MAP[focusedInput];
        this[refToFocus].focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate,
          startPlaceHolder = _this$props.startPlaceHolder,
          endPlaceHolder = _this$props.endPlaceHolder,
          onFocus = _this$props.onFocus,
          inputDelimeter = _this$props.inputDelimeter,
          inputDisplayFormat = _this$props.inputDisplayFormat;
      var formattedStartDate;
      var formattedEndDate;

      if (startDate) {
        formattedStartDate = moment(startDate).format(inputDisplayFormat);
      }

      if (endDate) {
        formattedEndDate = moment(endDate).format(inputDisplayFormat);
      }

      return React.createElement("div", {
        className: "eds-l-pad-all-2"
      }, React.createElement(DateInput, {
        classes: "eds-date-picker__range-input--start",
        onFocus: onFocus.bind(null, 'startDate'),
        date: formattedStartDate,
        placeholder: startPlaceHolder,
        getRef: this._getRef.bind(null, '_startDateInput'),
        dataSpec: "eds-date-range-picker__input--start"
      }), inputDelimeter, React.createElement(DateInput, {
        classes: "eds-date-picker__range-input--end",
        onFocus: onFocus.bind(null, 'endDate'),
        date: formattedEndDate,
        placeholder: endPlaceHolder,
        getRef: this._getRef.bind(null, '_endDateInput'),
        dataSpec: "eds-date-range-picker__input--end"
      }));
    }
  }]);

  return DateRangeInput;
}(PureComponent);

_defineProperty(DateRangeInput, "propTypes", {
  onFocus: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startPlaceHolder: EBPropTypes.translation,
  endPlaceHolder: EBPropTypes.translation,
  focusedInput: PropTypes.oneOf([START_DATE, END_DATE]),
  inputDelimeter: PropTypes.node,
  inputDisplayFormat: PropTypes.string
});

_defineProperty(DateRangeInput, "defaultProps", {
  inputDelimeter: React.createElement("span", {
    className: "eds-l-pad-hor-1"
  }, "-")
});

export { DateRangeInput as default };